import { FormattedMessage } from 'react-intl';
import { mapValues } from 'lodash';

import { PasswordField, TextField } from '@app/components';
import { sharedMessages } from '@app/translations';

export const fieldDescriptions = mapValues(
  {
    'BASIC/UNIQUE-ID+NAME': {
      nameField: (
        <FormattedMessage id="login.uniqueID" defaultMessage="Unique ID" />
      ),
      passwordField: (
        <FormattedMessage {...sharedMessages.authNameFieldLabel} />
      ),
    },
    'BASIC/BARCODE+NAME': {
      nameField: <FormattedMessage {...sharedMessages.barcode} />,
      passwordField: (
        <FormattedMessage {...sharedMessages.authNameFieldLabel} />
      ),
    },
    'BASIC/BARCODE+PASSWORD': {
      nameField: <FormattedMessage {...sharedMessages.barcode} />,
      passwordField: <FormattedMessage {...sharedMessages.password} />,
    },
    'BASIC/BARCODE+PIN': {
      nameField: <FormattedMessage {...sharedMessages.barcode} />,
      passwordField: <FormattedMessage {...sharedMessages.pin} />,
    },
  },
  ({ nameField, passwordField }, key) => [
    { label: nameField, name: 'barcode', component: TextField },
    {
      label: passwordField,
      name: 'pin',
      component: PasswordField,
    },
  ]
);

export const usernamePasswordFieldsDescription = [
  {
    label: <FormattedMessage id="login.username" defaultMessage="Username" />,
    name: 'username',
    component: TextField,
  },
  {
    label: <FormattedMessage id="login.password" defaultMessage="Password" />,
    name: 'password',
    component: PasswordField,
  },
];
